import { makeStyles, shorthands } from '@fluentui/react-components';

export const useSrOnlyStyles = makeStyles({
  srOnly: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    ...shorthands.borderWidth(0),
  },
});
